export default __webpack_public_path__ + "static/media/linkedin-certificate.f9b525ba.svg";